import { FilterChoice } from '../../common/components/SearchHeader/types/FilterChoice';
import { GenderChoice } from '../../common/components/SearchHeader/types/GenderChoice';
import { Maybe, ProfileFilters } from '../../common/schema/hannibal/types.generated';

export const profileFiltersFromChoice = (filterChoice: FilterChoice): Maybe<ProfileFilters> => {
  const {
    gender,
    hicaps,
    language,
    topic,
    onlineAppointments,
    governmentScheme,
    insurance,
    insuranceProgram,
    paymentMethod,
    pricingAvailable,
    vaccineType,
  } = filterChoice;

  const { specialist: specialty, treatment } = topic || {};

  return {
    gender: gender ? (gender === GenderChoice.MALE ? 'MALE' : 'FEMALE') : null,
    governmentSchemes: governmentScheme ? [governmentScheme] : undefined,
    hicaps: hicaps ? true : undefined,
    interestsOrProcedures: treatment ? [treatment] : null,
    languages: language ? [language] : null,
    networkOnlineAppointments: onlineAppointments ? true : undefined,
    pricingAvailable: pricingAvailable ? true : undefined,
    paymentMethods: paymentMethod ? [paymentMethod] : undefined,
    preferredHealthProviders: insurance ? [insurance] : null,
    preferredProviderPrograms: insuranceProgram ? [insuranceProgram] : null,
    specialists: specialty ? [specialty] : null,
    vaccines: vaccineType ? [vaccineType] : null,
  };
};
